import { render, staticRenderFns } from "./ThemeView.vue?vue&type=template&id=47c50422&scoped=true&"
import script from "./ThemeView.vue?vue&type=script&lang=js&"
export * from "./ThemeView.vue?vue&type=script&lang=js&"
import style0 from "./ThemeView.vue?vue&type=style&index=0&id=47c50422&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c50422",
  null
  
)

export default component.exports